import React from 'react'
import SubscriptionList from '../../features/cashflow/Subscription-List/SubscriptionList'

function SubscriptionInvoices() {
  return (
    <SubscriptionList />
  )
}

export default SubscriptionInvoices